
<div mat-dialog-title>Delete Securities<button class="close" mat-button title="Cancel" (click)="close()"><i class="material-icons clear" >clear</i></button></div>
<mat-dialog-content>
  <mat-card class="warn block">
    <mat-card-title class="warn" style="font-family: Arial;font-size: 13px;color: #000000;white-space: pre-line;">{{totalAffected}} selected
    securities will lose some specified usage
    rules. See explanations below</mat-card-title>
  </mat-card>
  <div class="block">If you continue, these security records will be affected as shown.</div>
    <div>
      <irb-inventory-grid
        [style.width] = "'100%'"
        [style.height] = "'240px'"
        [showSideBar] = "false"
        [gridOptions] = "gridOptions"
        [frameworkComponents] = 'frameworkComponents'
        [rowData] = 'data.response'
        (gridReady) = "onGridReady($event)"></irb-inventory-grid>
    </div>  
  </mat-dialog-content>

  <mat-dialog-actions >
    <button (click)="export()" class="btn-medium-tertiary export-btn">Export</button>
    <button  (click)="close()" class="btn-medium-secondary">Close</button>
    <button (click)="continue()" class="btn-medium-primary">Continue</button>
  </mat-dialog-actions>
  